<script>
    import { projection } from './store.js';
    import { geoPath } from 'd3-geo';

    let streets = {features: []}
    fetch("Abila.geojson")
        .then(result => result.json())
        .then(result => streets = result)
    $: features = streets.features

    const path = geoPath(projection)
</script>

<style>
    path {
        fill: none;
        stroke: black;
        stroke-width: 1;
        stroke-opacity: 0.5;
    }
</style>

{#each features as street}
    <path d={path(street)} />
{/each}
